import IconClose from '@creditflowresearch/uilib/Icon/IconClose';
import Title from '@creditflowresearch/uilib/Title';
import Flex from '@creditflowresearch/uilib/Flex';
import UpgradePlanButton from '@/creditflowresearch/ui/common/components/UpgradePlanButton';

import styles from './lockedFeaturePopupContent.module.scss';
import IconButton from '@creditflowresearch/uilib/IconButton';

interface IProps {
  title?: React.ReactNode,
  subtitle?: React.ReactNode,
  description?: React.ReactNode,
  onClose: () => void,
}

const LockedFeaturePopupContent = ({
  title = 'Upgrade to access',
  subtitle,
  description,
  onClose,
}: IProps) => {
  return (
    <Flex direction="column" align="flex-start" className={ styles.container }>
      <IconButton
        icon={ <IconClose className={ styles.icon } /> }
        color="primary"
        dataTest="LockedFeaturePopupCloseButton"
        className={ styles.buttonClose }
        onClick={ onClose }
        ariaLabel="Close"
      />
      <Title className={ styles.title } title={ title } />
      { subtitle && <Title className={ styles.title } title={ subtitle } /> }
      { description && <p className={ styles.description }>{ description }</p> }
      <UpgradePlanButton />
    </Flex>
);
};

export default LockedFeaturePopupContent;
